function resolvePath(target) {
    if (typeof target === 'string') {
        return target;
    }
    if (target instanceof URL) {
        return `${target.pathname}${target.search}`;
    }
    return target.url;
}
function extractDpopAccessToken(headers) {
    const auth = new Headers(headers).get('Authorization');
    if (!auth?.startsWith('DPoP ')) {
        return undefined;
    }
    const token = auth.slice('DPoP '.length);
    return token || undefined;
}
function captureDpopNonce(res, deviceKeyStore) {
    const nonce = res.headers.get('DPoP-Nonce');
    if (nonce) {
        deviceKeyStore.setDpopNonce(nonce);
    }
}
/**
 * 요청마다 DPoP 증명 헤더를 붙이고, 서버 nonce 갱신 시 한 번 재시도한다.
 */
export function dpopHeaderLayer(deviceKeyStore) {
    return (next) => async (path, init) => {
        const method = (init?.method ?? 'GET').toUpperCase();
        const htu = resolvePath(path);
        const accessToken = extractDpopAccessToken(init?.headers);
        const attempt = async () => {
            const proof = await deviceKeyStore.createDpopProof({
                htm: method,
                htu,
                accessToken,
            });
            const headers = new Headers(init?.headers);
            if (proof) {
                headers.set('DPoP', proof);
            }
            return next(path, { ...init, headers });
        };
        let res = await attempt();
        captureDpopNonce(res, deviceKeyStore);
        // 서버가 새 nonce를 요구하면 갱신된 nonce로 증명을 다시 보낸다.
        if ((res.status === 400 || res.status === 401) && res.headers.get('DPoP-Nonce')) {
            res = await attempt();
            captureDpopNonce(res, deviceKeyStore);
        }
        return res;
    };
}
//# sourceMappingURL=dpopHeaderLayer.js.map